import { Link, useLocation } from 'react-router-dom';
import { useAuth } from 'context/AuthContext';

const LABELS = {
  '': 'Vue 360\u00B0',
  agents: 'Agents',
  sites: 'Monitoring temps reel',
  rondes: 'Rondes & Patrouilles',
  incidents: 'Incidents & Alertes',
  vehicules: 'Vehicules',
  clients: 'Clients (CRM)',
  equipements: 'Equipement / Materiel',
  facturation: 'Facturation',
  paie: 'Paie & Bulletins',
  charges: 'Charges & Depenses',
  'compte-resultat': 'Compte de resultat',
  'export-comptable': 'Export comptable',
  formations: 'Formations',
  validations: 'Validations',
  'contrats-travail': 'Contrats de travail',
  utilisateurs: 'Utilisateurs & Roles',
  'agenda-dg': 'Agenda DG',
  courriers: 'Courriers',
  'comptes-rendus': 'Comptes rendus',
  archivage: 'Archivage',
  telesurveillance: 'Telesurveillance',
  commerce: 'Commerce & Stock',
  devis: 'Devis',
  controleur: 'Controle terrain',
  cynophile: 'Cynophile (Maitres-chiens)',
  'agents-rh': 'Fiches du personnel',
  'classement-agents': 'Classement des agents',
  'revision-grille': 'Révision de la grille',
  pointage: 'Pointage journalier',
  conges: 'Permissions & Conges',
  catalogue: 'Catalogue produits',
  'journal-veille': 'Journal de veille',
  alarmes: 'Alarmes',
  'logs-audit': "Logs d'audit",
  parametres: 'Parametres',
  'import-donnees': 'Import donnees',
  profil: 'Mon profil',
  encaissements: 'Encaissements',
  tresorerie: 'Caisse & Banque',
  'previsions-tresorerie': 'Previsions tresorerie',
  fournisseurs: 'Fournisseurs',
  'paie-sociale': 'Paie & Charges sociales',
  bilan: 'Bilan comptable',
  'flux-tresorerie': 'Flux de tresorerie',
  ratios: 'Ratios financiers',
  budget: 'Budget & Previsions',
  'plan-comptable': 'Plan comptable',
  journaux: 'Journaux comptables',
  'grand-livre': 'Grand livre',
  balance: 'Balance generale',
  immobilisations: 'Immobilisations',
  exercices: 'Exercices comptables',
  'export-fec': 'Export FEC',
  ia: 'Intelligence IA',
};

const SECTIONS = {
  sites: 'Centre de commandement',
  incidents: 'Centre de commandement',
  agents: 'Operations terrain',
  rondes: 'Operations terrain',
  controleur: 'Operations terrain',
  vehicules: 'Operations terrain',
  equipements: 'Operations terrain',
  cynophile: 'Operations terrain',
  'agents-rh': 'Ressources humaines',
  'classement-agents': 'Ressources humaines',
  'revision-grille': 'Ressources humaines',
  'contrats-travail': 'Ressources humaines',
  formations: 'Ressources humaines',
  pointage: 'Ressources humaines',
  conges: 'Ressources humaines',
  paie: 'Ressources humaines',
  clients: 'Comptabilite & Finance',
  devis: 'Comptabilite & Finance',
  facturation: 'Comptabilite & Finance',
  charges: 'Comptabilite & Finance',
  'compte-resultat': 'Comptabilite & Finance',
  'export-comptable': 'Comptabilite & Finance',
  encaissements: 'Comptabilite & Finance',
  tresorerie: 'Comptabilite & Finance',
  'previsions-tresorerie': 'Comptabilite & Finance',
  fournisseurs: 'Comptabilite & Finance',
  'paie-sociale': 'Comptabilite & Finance',
  bilan: 'Comptabilite & Finance',
  'flux-tresorerie': 'Comptabilite & Finance',
  ratios: 'Comptabilite & Finance',
  budget: 'Comptabilite & Finance',
  'plan-comptable': 'Comptabilite & Finance',
  journaux: 'Comptabilite & Finance',
  'grand-livre': 'Comptabilite & Finance',
  balance: 'Comptabilite & Finance',
  immobilisations: 'Comptabilite & Finance',
  exercices: 'Comptabilite & Finance',
  'export-fec': 'Comptabilite & Finance',
  ia: 'Intelligence IA',
  catalogue: 'Commerce & TSV',
  commerce: 'Commerce & TSV',
  telesurveillance: 'Commerce & TSV',
  'journal-veille': 'Commerce & TSV',
  alarmes: 'Commerce & TSV',
  'agenda-dg': 'Assistanat Direction',
  courriers: 'Assistanat Direction',
  'comptes-rendus': 'Assistanat Direction',
  archivage: 'Assistanat Direction',
  utilisateurs: 'Administration',
  validations: 'Administration',
  'logs-audit': 'Administration',
  parametres: 'Administration',
  'import-donnees': 'Administration',
};

const ROLE_TITLES = {
  dg: 'Direction Generale', admin: 'Direction Generale',
  rh: 'Ressources Humaines', assistante_direction: 'Assistanat Direction',
  cos: 'Chef des Operations', superviseur_general: 'Supervision Generale',
  superviseur_assistant: 'Supervision', controleur: 'Controle Terrain',
  comptable: 'Comptabilite', responsable_commercial: 'Commercial',
  operateur_tsv: 'Telesurveillance',
};

export default function BreadcrumbNav() {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const segments = pathname.split('/').filter(Boolean);

  if (segments.length === 0) {
    const roles = user?.roles || [];
    const primaryRole = roles.find(r => ROLE_TITLES[r]) || roles[0];
    const dept = ROLE_TITLES[primaryRole];
    if (!dept) return null;
    return (
      <nav className="breadcrumb" aria-label="Fil d'Ariane">
        <span className="breadcrumb-link" style={{ color: '#999' }}>Centre de commandement</span>
        <span className="breadcrumb-sep">&gt;</span>
        <span className="breadcrumb-current">{dept}</span>
      </nav>
    );
  }

  const page = segments[0];
  const section = SECTIONS[page];
  const label = LABELS[page] || page;

  return (
    <nav className="breadcrumb" aria-label="Fil d'Ariane">
      <Link to="/" className="breadcrumb-link">Vue 360&deg;</Link>
      {section && (
        <>
          <span className="breadcrumb-sep">&gt;</span>
          <span className="breadcrumb-section">{section}</span>
        </>
      )}
      <span className="breadcrumb-sep">&gt;</span>
      <span className="breadcrumb-current">{label}</span>
    </nav>
  );
}
